import { css } from "@emotion/react";
import { theme } from "styles/theme";

export const SideBarMenuStyles = {
  index: (isSidebar: boolean) => css`
    position: fixed;
    top: 0;
    left: 0;
    width: 300px;
    height: 100%;
    background: rgba(0, 0, 0, 0.9);
    overflow: hidden;
    z-index: 99;
    transform: translateX(${isSidebar ? "0px" : "-300px"});
    transition: 0.25s all;
  `,
  overlay: (isSidebar: boolean) => css`
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 98;
    display: ${isSidebar ? "block" : "none"};
  `,
  header: css`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 16px 8px;
  `,
  content: css`
    height: 100%;
    overflow-y: auto;
    padding-bottom: 16px;
    ::-webkit-scrollbar {
      width: 0px;
      background-color: ${theme.colors.primary[700]};
    }
    ::-webkit-scrollbar-thumb:hover {
      width: 0px;
      background-color: ${theme.colors.primary[700]};
    }
  `,
  sidebarBg: css`
    padding: 24px 5px;
    img {
      width: 100%;
      object-fit: contain;
    }
  `,
  listMenu: css`
    display: flex;
    flex-direction: column;
  `,
  itemMenu: css`
    padding: 12px 8px;
    text-decoration: none;
    display: flex;
    align-items: center;

    span {
      margin-left: 11px;
      color: ${theme.colors.white};
      font-size: 14px;
      font-weight: 400;
    }
  `,
};
